import { X, Upload } from 'lucide-react'
import PropTypes from 'prop-types'
import { useCallback, useEffect, useRef, useState } from 'react'

import { CaradasLogoWrapper } from '@components/logo-wrapper'
import { AdasBox, AdasLinearProgress, AdasImage } from '@components/wrapper-components'
import { deleteCalibrationCenterLogo, useUploadCalibrationCenterLogo } from '../../../api/api'

export const CalibrationCenterLogo = (props) => {
  const { calibrationCenterData, isEdit, onSuccess } = props
  const [imageUrl, setImageUrl] = useState(calibrationCenterData.image)
  const fileRef = useRef(null)
  const { progress, uploadData, isSuccess } = useUploadCalibrationCenterLogo()

  const uploadFile = useCallback(
    async (file) => {
      const formData = new FormData()
      formData.append('file', file, file.name)
      const params = {
        data: formData,
        ccId: calibrationCenterData.id
      }
      const response = uploadData(params)
      response.then(() => {
        onSuccess()
      })
    },
    [calibrationCenterData.id, onSuccess, uploadData]
  )

  const handleUpload = () => {
    uploadFile(fileRef.current.files[0])
  }

  const handleClose = async () => {
    setImageUrl(null)
    const params = {
      ccId: calibrationCenterData.id
    }
    const deleteCCLogoResponse = await deleteCalibrationCenterLogo(params)
    if (deleteCCLogoResponse.status === 200) {
      onSuccess()
    }
  }

  useEffect(() => {
    setImageUrl(calibrationCenterData.image)
  }, [calibrationCenterData])

  return !imageUrl ? (
    isEdit ? (
      <AdasBox>
        <AdasBox className='flex mb-[20px] h-[200px]'>
          <label className='m-auto inline-flex cursor-pointer items-center gap-2 rounded-md px-4 py-2 text-xs font-semibold uppercase text-primary hover:bg-muted'>
            <Upload className='h-4 w-4' />
            <span>UPLOAD LOGO FILE - SVG, PNG, JPG</span>
            <input ref={fileRef} type='file' accept='image/*' hidden onChange={handleUpload} />
          </label>
        </AdasBox>
        {progress > 0 && !isSuccess && <AdasLinearProgress value={progress} />}
      </AdasBox>
    ) : (
      <CaradasLogoWrapper />
    )
  ) : (
    <AdasBox className='my-5 mx-0 p-2 border border-[black]'>
      {isEdit && <X style={{ float: 'right', cursor: 'pointer' }} onClick={handleClose} />}
      <AdasImage src={imageUrl} alt='dash' className='w-full object-contain h-[200px]' />
    </AdasBox>
  )
}

CalibrationCenterLogo.propTypes = { calibrationCenterData: PropTypes.object, isEdit: PropTypes.bool, onSuccess: PropTypes.func.isRequired }
